// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".but-row[data-v-5e30a288] {\n  text-align: center;\n}\n.line-chart[data-v-5e30a288] {\n  height: 590px;\n}", ""]);
// Exports
module.exports = exports;
